// extracted by mini-css-extract-plugin
export default {"loginInput":"login_loginInput__ciXcv","formInput":"login_formInput__7MeE2","formArea":"login_formArea__4TBLX","loginButton":"login_loginButton__8MUGZ"};